/**
 * src/services/employeeAuth.service.js
 * Client-side authentication service for employees using JWT
 */
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

class EmployeeAuthService {
  async login(employeeId, password) {
    try {
      const response = await axios.post(`${API_URL}/api/employee-auth/signin`, {
        employeeId,
        password
      });

      if (response.data.accessToken) {
        this.setUser(response.data);
      }

      return response.data;
    } catch (error) {
      console.error("Employee login error:", error);
      throw error;
    }
  }

  logout() {
    const refreshToken = this.getRefreshToken();

    // Call the signout endpoint
    if (refreshToken) {
      axios.post(`${API_URL}/api/employee-auth/signout`, {
        refreshToken: refreshToken
      }).catch(error => console.error('Logout error:', error));
    }

    // Clear local storage
    localStorage.removeItem('employeeUser');
  }

  setUser(user) {
    localStorage.setItem('employeeUser', JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem('employeeUser'));
  }

  getAccessToken() {
    const user = this.getUser();
    return user ? user.accessToken : null;
  }

  getRefreshToken() {
    const user = this.getUser();
    return user ? user.refreshToken : null;
  }

  isLoggedIn() {
    return !!this.getAccessToken();
  }

  isEmployee() {
    const user = this.getUser();
    return user && user.role === 'employee';
  }

  async refreshToken() {
    try {
      const refreshToken = this.getRefreshToken();

      if (!refreshToken) {
        return false;
      }

      const response = await axios.post(`${API_URL}/api/employee-auth/refreshtoken`, {
        refreshToken: refreshToken
      });

      const user = this.getUser();
      user.accessToken = response.data.accessToken;

      this.setUser(user);
      return true;
    } catch (error) {
      console.error('Token refresh error:', error);
      this.logout();
      return false;
    }
  }
}

export default new EmployeeAuthService();